import script from "./sport-live-tv-catalog.vue?vue&type=script&setup=true&lang=js"
export * from "./sport-live-tv-catalog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__